import Reveal from "./Reveal";

export default function Manifesto() {
  return (
    <section
      data-testid="manifesto-section"
      className="relative py-28 md:py-40 bg-[color:var(--bs-cream)]"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <Reveal>
          <h2 className="font-display text-5xl md:text-7xl lg:text-8xl font-light tracking-tight leading-[0.95] text-[color:var(--bs-ink)] max-w-5xl balance">
            Offrez-vous une{" "}
            <span className="italic text-[color:var(--bs-gold)]">expérience</span>{" "}
            inoubliable.
          </h2>
        </Reveal>
      </div>
    </section>
  );
}
